import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import GeneralDatePickerComponent from '../../components/GeneralDatePickerComponent';

interface TopChipsProps {
    mainContent: Array<any>;
    setDisplayedData: (data: any[]) => void;
    outsideHooks:any
}

const PricesListTopComponent: React.FC<TopChipsProps> = ({ mainContent, setDisplayedData,outsideHooks }) => {


    const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        outsideHooks.setChecked(event.target.checked);

        console.log('Toggle switched:', event.target.checked);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                flexDirection: 'row',
                padding: 0,
                '&::-webkit-scrollbar': {
                    display: 'none'
                }
            }}
        >
            <GeneralDatePickerComponent singleDateMode={true} mainContent={mainContent} setDisplayedData={setDisplayedData} date={outsideHooks.date} setDate={outsideHooks.setDate}/>
            <FormControlLabel
                sx={{ margin: 0 }}
                control={<Switch checked={outsideHooks.checked} onChange={handleToggleChange} />}
                label="כל מוצרי המערכת"
            />
        </Box>
    );
};

export default PricesListTopComponent;
